// @flow

import DOMPurify from 'dompurify';

// https://github.com/cure53/DOMPurify
const clean = (dirty: string): string =>
  DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });

export default clean;
